import { useUserData } from "../../../features/user/hooks/useUserData";
import { useHomeDashboard } from "./useHomeDashboard";

export function useHomeData() {
  const { data: user, loading: loadingUser } = useUserData();
  const { data: homeDashboard, loading: loadingDashboard } = useHomeDashboard();

  return {
    user,
    homeDashboard,
    loadingDashboard,
  };
}
